import { render, staticRenderFns } from "./ProductModifiers.vue?vue&type=template&id=026d1ae6&scoped=true&"
import script from "./ProductModifiers.vue?vue&type=script&lang=js&"
export * from "./ProductModifiers.vue?vue&type=script&lang=js&"
import style0 from "./ProductModifiers.vue?vue&type=style&index=0&id=026d1ae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026d1ae6",
  null
  
)

export default component.exports